import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Video, X, Lock, Crown } from "lucide-react";

export default function VideoCallModal({ open, onClose, character, locked, onUpgrade }) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-ink border-white/10 rounded-3xl max-w-md p-0 overflow-hidden" data-testid="video-call-modal">
        <DialogTitle className="sr-only">Video call with {character?.name}</DialogTitle>
        <DialogDescription className="sr-only">Premium video calling experience.</DialogDescription>
        <div className="relative aspect-[3/4] w-full">
          <img src={character?.active_outfit_url || character?.avatar_url} alt=""
            className={`w-full h-full object-cover ${locked ? "scale-105" : ""}`} />
          {/* scan loop line */}
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <div className="absolute left-0 right-0 h-px bg-brand/60 animate-pulse-glow" style={{ top: "40%" }} />
          </div>

          <div className="absolute top-4 left-4 flex items-center gap-2 glass px-3 py-1.5 rounded-full">
            <span className="w-2 h-2 rounded-full bg-brand animate-pulse" />
            <span className="text-xs font-medium">LIVE</span>
          </div>

          {locked && (
            <div className="group absolute inset-0 z-20 backdrop-blur-md group-hover:backdrop-blur-[2px] bg-black/60 group-hover:bg-black/40 flex flex-col items-center justify-center p-8 text-center overflow-hidden transition-all duration-300">
              <div className="absolute inset-0 -z-10 opacity-15 group-hover:opacity-45 plasma group-hover:plasma-fast transition-opacity duration-300" />
              <div className="w-14 h-14 rounded-2xl bg-brand flex items-center justify-center mb-4 brand-glow">
                <Lock className="w-7 h-7 text-white" />
              </div>
              <h3 className="font-heading text-xl font-bold">Video Call Locked</h3>
              <p className="text-sm text-muted-foreground mt-2 leading-relaxed">
                Subscribe to Premium to unlock real-time, high-definition interactive visual streaming with your customized partner.
              </p>
              <Button data-testid="video-upgrade-button" onClick={onUpgrade}
                className="mt-5 h-12 px-6 rounded-full bg-brand hover:bg-brand-hover text-white font-semibold transition-colors">
                <Crown className="w-4 h-4 mr-2" /> Unlock Video
              </Button>
            </div>
          )}

          <button data-testid="video-end-button" onClick={onClose}
            className="absolute bottom-5 left-1/2 -translate-x-1/2 w-14 h-14 rounded-full bg-destructive flex items-center justify-center hover:opacity-90 transition-opacity z-30">
            <X className="w-6 h-6 text-white" />
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
